<template>
  <div class="undeveloped v-flex v-flex-wrap v-row-center">
    <div class="un-icon v-flex  v-row-center">
      <div class="icons"></div>
    </div>
    <div class="text">正在开发中...</div>
  </div>
</template>

<script>
export default {
  name: "undeveloped"
};
</script>

<style lang="scss" scoped>
.undeveloped {
  width: 100%;
  height: auto;
  padding: 0.25rem;

  .un-icon {
    width: 100%;

    .icons {
      width: 10.65rem;
      height: 6.4rem;
      background: url("../../assets/images/status/undeveloped.png") no-repeat;
      background-size: 100% 100%;
    }

  }

  .text {
    width: auto;
    height: auto;
    font-size: 0.55rem;
    font-family: "隶书";
    text-align: center;
    margin: 20px 0;
    color: #146cd4;
    -webkit-animation: anima_jelly 2s infinite;
  }


  //.anima_jelly {
  //  -webkit-animation: anima_jelly 2s infinite;
  //}

  @-webkit-keyframes anima_jelly {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1)
    }
    15% {
      -webkit-transform: scale3d(1.25, .75, 1);
      transform: scale3d(1.25, .75, 1)
    }
    20% {
      -webkit-transform: scale3d(0.75, 1.25, 1);
      transform: scale3d(0.75, 1.25, 1)
    }
    25% {
      -webkit-transform: scale3d(1.15, .85, 1);
      transform: scale3d(1.15, .85, 1)
    }
    32.5% {
      -webkit-transform: scale3d(.95, 1.05, 1);
      transform: scale3d(.95, 1.05, 1)
    }
    37.5% {
      -webkit-transform: scale3d(1.05, .95, 1);
      transform: scale3d(1.05, .95, 1)
    }
    50%, 100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1)
    }
  }


}
</style>